import React, { useState,useContext } from 'react';
import { withRouter, Link, useHistory } from 'react-router-dom';
import app from '../../firebase/base.js';
import {Footer} from '../footer.js';
import './signup.css';
import { UserContext } from '../UserContext.js';
import Navbar2 from '../Nav2.js';


const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [number, setNumber] = useState("");
  // const [userId, setUserId] = useState(null);
  const { userId, setUserId } = useContext(UserContext);

  const history = useHistory();
  const handleSignUp = (event) => {
    event.preventDefault();
    app
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then((userInfo) => {
        setUserId(userInfo.user.uid);
        app.firestore().collection("users").doc(userInfo.user.uid).set({
          email: email,
          number: number,
      })
        console.log("Sign up successful:", userInfo);
        history.push("/");
      })
      .catch((error) => {
        console.error("Sign up error:", error);
      });
  };


  
  const getUserData = async () => {
    const userRef = app.firestore().collection("users").doc(userId || '6YVUdWekWgdC6RB6zB2oDiNLm2u2');
    const doc = await userRef.get();
    if (!doc.exists) {
      console.log("No such document!");
    } else {
      console.log("Document data:", doc.data());
    }
  };



    return (
        <div id="background" className="gradient__bg">
          <Navbar2/>
          <div className="SignUp">
            <div className="signup-container">
              <h1 ><span >ScanEL</span></h1>
              <form className='signup-form' onSubmit={handleSignUp}>
                <input className="input-email" name="email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}/>
                {/* <button onClick={getUserData}>test</button> */}
                <input className="input-password" name="password" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                <input className="input-text " value={number} name="number" type="text" placeholder="Number" onChange={(e) => setNumber(e.target.value)} />
                <button className="signup_submit " type="submit">Sign Up</button>
                <p >Already have an account? <a href="/login" className="cursor-pointer">Log In</a></p>
              </form>
            </div>
          </div>
          <Footer />
        </div>
  );
}

export default withRouter(Signup);